module.exports = __webpack_public_path__ + "static/running-79c88dbfc60e1e21b9c8cfd80e8a9197.mp4";